/** Service types for Service Log */
export const SERVICE_LOG_TYPES = [
  "monthly_in_service_training",
  "infection_control_training",
  "hipaa_training",
  "osha_safety_training",
  "emergency_preparedness",
  "patient_rights_training",
  "abuse_neglect_prevention",
  "documentation_training",
  "equipment_training",
  "ppe_training",
  "hand_hygiene_training",
  "staff_meeting",
  "case_conference",
  "skills_competency_check",
  "quality_assurance_review",
  "other",
];

/** Display labels for service types */
export const SERVICE_LOG_TYPE_LABELS = {
  monthly_in_service_training: "Monthly In-Service Training",
  infection_control_training: "Infection Control Training",
  hipaa_training: "HIPAA Training",
  osha_safety_training: "OSHA Safety Training",
  emergency_preparedness: "Emergency Preparedness",
  patient_rights_training: "Patient Rights Training",
  abuse_neglect_prevention: "Abuse & Neglect Prevention",
  documentation_training: "Documentation Training",
  equipment_training: "Equipment Training",
  ppe_training: "PPE Training",
  hand_hygiene_training: "Hand Hygiene Training",
  staff_meeting: "Staff Meeting",
  case_conference: "Case Conference",
  skills_competency_check: "Skills Competency Check",
  quality_assurance_review: "Quality Assurance Review",
  other: "Other",
};
